
export const helpers = {
    methods: {
        showErrors(data)
        {
            let str = '';

            str += "<strong>Fehler:</strong><br>";

            for (let [key, value] of Object.entries(data.errors))
            {
                str += value + "<br>";
                console.log(`${key}: ${value}`);
            }

            return str;
        },
    }
};